import { SubscriptionStatus, User, VoucherCategory } from '@novaheal/types';
import type { FeatureFlagName } from 'types/FeatureFlag';

export const hasActiveB2BVoucher = (user: User | null | undefined): boolean =>
  user?.subscription?.status === SubscriptionStatus.VOUCHER &&
  user?.voucher?.category === VoucherCategory.B2B;

type CanUseWorksheetFeedbackSummaryParams = {
  user: User | null | undefined;
  isEnabled: (name: FeatureFlagName) => boolean;
};

export const canUseWorksheetFeedbackSummary = ({
  user,
  isEnabled,
}: CanUseWorksheetFeedbackSummaryParams): boolean => {
  if (!user) {
    return false;
  }

  if (user.shouldShowAI === true) {
    return true;
  }

  if (user.b2bSchool?.hasWorksheetFeedbackSummaryAccess === true) {
    return true;
  }

  if (hasActiveB2BVoucher(user)) {
    return isEnabled('isWorksheetFeedbackSummaryEnabledForB2B');
  }

  return isEnabled('isWorksheetFeedbackSummaryEnabledForB2C');
};
